/**
 * All queries relating to Rigs
 */

import gql from "graphql-tag";

export const RigFragment = gql`
    fragment RigFragment on Rig {
        _id
        locationID {
            _id
            name
        }
        name
        bldgQuartersIds
        sectQuartersIds
        bunkQuartersIds
        bedQuartersIds
        onboardPobIdList
        expectedPobIdList
        departingPobIdList
    }
`
